import React from 'react';

import { month_name } from '../../../../services/services';
import { T } from '../../../../../../common/locale/translate';

const fixMontNameError = (month, temp) => {
  //in weather data there is a month name mistake 'sepember' instead of september
  if (month !== 'september') {
    return month;
  } else {
    if (typeof temp.day[month] !== 'undefined') {
      return month;
    } else {
      return 'sepember';
    }
  }
};

const WeatherWidget = props => {
  let month = month_name(props.departure_date),
    temp = props.weather.temperatures;

  month = fixMontNameError(month, temp);

  return (
    <div className="weather-widget">
      <div className="widgets-wrapper">
        <div className="air-temperature">
          <span className="icon" />
          <span className="temperature">
            {temp.day[month] ? temp.day[month] : ' - '}°C
          </span>
        </div>
        <div className="water-temperature">
          <span className="icon" />
          <span className="temperature">
            {temp.water[month] ? temp.water[month] : ' - '}°C
          </span>
        </div>
      </div>
      <div className="widget-description">
        <span className="title">{T('widget_description')}</span>
      </div>
    </div>
  );
};

export default WeatherWidget;



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/weather/widget.js